"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useRsvpToSessions = void 0;
var _react = require("react");
var _utils = require("../../../utils");
var _types = require("../../../types");
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0) { ; } } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var createRsvp = function createRsvp(sessionId) {
  _utils.api.post((0, _utils.getGroupSessionRsvpUrl)(), {
    groupSessionId: sessionId,
    status: _types.RsvpStatus.Attending
  });
};
var deleteRsvp = function deleteRsvp(rsvpId) {
  return _utils.api.delete((0, _utils.deleteGroupSessionRsvpUrl)(rsvpId));
};
var useRsvpToSessions = function useRsvpToSessions() {
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    processing = _useState2[0],
    setProcessing = _useState2[1];
  var onCreateRsvps = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(sessionIds) {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              setProcessing(true);
              _context.next = 3;
              return Promise.all(sessionIds.map(createRsvp));
            case 3:
              setProcessing(false);
            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));
    return function onCreateRsvps(_x) {
      return _ref.apply(this, arguments);
    };
  }();
  var onCancelRsvp = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(rsvpId) {
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              setProcessing(true);
              _context2.next = 3;
              return deleteRsvp(rsvpId);
            case 3:
              setProcessing(false);
            case 4:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));
    return function onCancelRsvp(_x2) {
      return _ref2.apply(this, arguments);
    };
  }();
  return {
    onCreateRsvps: onCreateRsvps,
    onCancelRsvp: onCancelRsvp,
    processing: processing
  };
};
exports.useRsvpToSessions = useRsvpToSessions;